import { render, staticRenderFns } from "./Resultados.vue?vue&type=template&id=64be79f4&scoped=true&"
import script from "./Resultados.vue?vue&type=script&lang=js&"
export * from "./Resultados.vue?vue&type=script&lang=js&"
import style0 from "./Resultados.vue?vue&type=style&index=0&id=64be79f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64be79f4",
  null
  
)

export default component.exports